<template>
  <div  class="enum-container">
    <div class="enum">
      <button
        type="button"
        v-for="(enumValue, idx) in displayedValues"
        :key="idx"
        :disabled="!allowEdit"
        :class="['option', { selected: isSelected(enumValue.value) }]"
        @click.prevent="changeValue(enumValue.value)"
      >
          <i v-if="enumValue.icon && enumValue.text" :class="enumValue.icon" :key="`${idx}_${enumValue.text}`" v-tooltip="{ data: enumValue.text, arrowPosition: 'top'}"></i>
          <i v-else-if="enumValue.icon" :class="enumValue.icon"></i>
        <template v-else-if="enumValue.text">{{ enumValue.text }}</template>
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Constants from "@/store/constants";
import Translations from "@/store/translations";
import Tooltip from "@/components/common/Tooltip.vue";

export default {
  name: "MultiChoiceTextInput",
  components: {
    Tooltip
  },
  props: {
    enumValues: { type: [Object, Array], required: true },
    originalValue: { type: [Number, Array, String], default: null },
    allowEdit: { type: Boolean, default: true },
    multiselect: { type: Boolean, default: false }
  },
  watch: {
      originalValue: {
          handler: function (val) {
              this.value = val;
          }
      }
  },
  computed: {
    displayedValues() {
      if (this.allowEdit || false)
        return this.enumValues;
      else {
        let enumValue = this.displayedValue;   
        if (enumValue)
          return [enumValue];
        return [];    
      } 
    },
    displayedValue() {
      if (this.value == null) return {};
      if (this.enumValues == null) return {};
      return this.enumValues[this.value] || {};
    }
  },
  data() {
    return {
      viewState: {
        isInEditMode: false
      },
      value: this.originalValue
    };
  },
  methods: {
    resetValue(newValue) {
      this.value = newValue;
    },
    changeValue(newValue) {
      if (this.multiselect) {
        if (!this.value || !Array.isArray(this.value)) {
          this.value = [];
        }

        const position = this.value.indexOf(newValue);

        if (position === -1) {
          this.value.push(newValue);
        } else {
          this.value.splice(position, 1);
        }

        this.$emit("onValueChanged", this.value);
        return;
      }

      this.value = newValue;

      // if (this.value == this.originalValue) {
      //   return;
      // }
      this.$emit("onValueChanged", this.value);
    },
    isSelected(val) {
      if (!this.value) {
        return false;
      }

      if (this.multiselect) {
        for (let i = 0; i < this.value.length; i++) {
          const v = this.value[i];
          if (val === v) {
            return true;
          }
        }
        
        return false;
      }
      
      return val === this.displayedValue.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.enum-container {
  white-space: nowrap;
  display: inline-block;
  text-align: center;
  height: 30px;

  .enum {
    margin-left: -0.5em;
  }
}

.enum-container button.option {
  background: transparent;
  cursor: pointer;
  line-height: 30px;
  text-align: center;
  display: inline-block;
  padding: 0 0.5em;
  border-radius: 5px;
  color: #d2d2d2;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out;

  .table-footer & {
    color: #fff;
  }
}

.enum-container button.option:focus {
  // color: black;
  outline: none;
}

.enum-container .option:not(:disabled):hover,
.enum-container .option.selected {
  color: black;
}

.enum-container .option:disabled:not(.selected) {
  color: #d2d2d2 !important;
  cursor: default !important;

  &:hover i {
    color: #d2d2d2 !important;
    cursor: default;
  }
}

.enum-container .option.selected:disabled {
  color: black !important;
  cursor: default !important;

  &:hover i {
    color: black !important;
    cursor: default;
  }
}

.enum-container .mood {
  display: inline-block;
}

.enum-container .mood:nth-child(2n + 1) {
  margin: 0 5px;
}
</style>
